import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import '../styles/application.css'

const pages = import.meta.glob(['../pages/**/*.tsx', '!../pages/**/*.test.tsx', '!../pages/**/*.spec.tsx'], { eager: true }) as Record<string, { default: React.ComponentType }>

createInertiaApp({
  resolve: (name) => {
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      throw new Error(`Page not found: ${name}`)
    }
    return page
  },
  setup({ el, App, props }) {
    if (el) {
      createRoot(el).render(<App {...props} />)
    }
  },
})
